import React from 'react';
import { PureComponent } from '../../../dispatcher/modules';
import Container from '../container/Container';
import { PUZZLE_PANEL_PROPS } from './Types';

class PuzzlePanel extends PureComponent<PUZZLE_PANEL_PROPS, {}> {
  constructor(props) {
    super(props);

    this.state = {
      isCollapsed: props.initialCollapsed || false
    };
  }

  /**
   * Handler for collapsing/extending panel content container
   */
  toggleCollapse = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    });
  }

  render() {
    const { isCollapsed } = this.state;
    let {
      titleId,
      children,
      title,
      className = '',
      titleLine,
      titleClassName,
      panelMandatory,
      legendOnly,
      tabIndex = 0,
      preventFocus,
      isCollapsible = false
    } = this.props;

    if (preventFocus) {
      tabIndex = undefined;
    }

    return (
      <Container
        htmlTag={'fieldset'}
        className={`tp-panel ${className}`}
        tabIndex={tabIndex}
      >
        <legend className="sr-only">{title}</legend>
        <Container
          displayFlex
          alignItemsCenter
          id={titleId}
          className={`tp-panel-title tp-text-semibold ${titleClassName ? titleClassName : ''}`}
        >
          {isCollapsible && <i
            onClick={this.toggleCollapse}
            className={`tp-icon tp-icon-md tp-pointable tp-color-blue-500 ${isCollapsed ? 'tp-arrow-chevron-down' : 'tp-arrow-chevron-up'}`}
          />}
          {!legendOnly && <span>{title}</span>}
          {panelMandatory && <span className='tp-panel-mandatory'>*</span>}
          {titleLine && <div className={'tp-title-line k-flex-1'} />}
        </Container>
        {isCollapsed ? null : children}
      </Container>
    );
  }
}

export default PuzzlePanel;
